module.exports = __webpack_public_path__ + "img/2.20ebae59.jpg";